module.exports = {
  RELEASE_YEAR: 2022,
  BRAND_NAME: 'Maestria',
  BRAND_SHORT_NAME: 'Maestria',
  SITE_URL: 'https://maestrialaw.com.br',
  SITE_DESCRIPTION: '',
  TWITTER_NAME: '@maestria',
  FACEBOOK_NAME: '@maestria'
}
